import { render, staticRenderFns } from "./ScarPlugIn.vue?vue&type=template&id=2cc0e855&scoped=true"
import script from "./ScarPlugIn.vue?vue&type=script&lang=js"
export * from "./ScarPlugIn.vue?vue&type=script&lang=js"
import style0 from "./ScarPlugIn.vue?vue&type=style&index=0&id=2cc0e855&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc0e855",
  null
  
)

export default component.exports